import { createI18n } from 'vue-i18n'
import fr from './locales/fr.json'
import en from './locales/en.json'
import es from './locales/es.json'

const supportedLocales = ['fr', 'en', 'es']

function detectLocale() {
  // Check ?l= query param (e.g. ?l=en) and persist it
  const urlParams = new URLSearchParams(window.location.search)
  const queryLocale = urlParams.get('l')
  if (queryLocale && supportedLocales.includes(queryLocale)) {
    localStorage.setItem('locale', queryLocale)
    return queryLocale
  }

  const saved = localStorage.getItem('locale')
  if (saved && supportedLocales.includes(saved)) return saved

  const browserLang = (navigator.language || navigator.userLanguage || '').split('-')[0]
  if (supportedLocales.includes(browserLang)) return browserLang

  return 'fr'
}

const savedLocale = detectLocale()

const i18n = createI18n({
  legacy: true,
  locale: savedLocale,
  fallbackLocale: 'fr',
  messages: { fr, en, es }
})

export default i18n
